<template>
  <div>
    <v-card class="pa-0 pb-10" tile>
      <v-card-title>
        <h4 class="primary--text">
          {{ $t('tslContractors.title') }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$store.getters.isOwner || $store.getters.isManager"
          color="primary"
          @click="openImportDialog"
          class="mr-2"
          depressed
        >
          {{ $t('tslContractors.import') }}
        </v-btn>
      </v-card-title>
      <div class="background px-6 my-4">
        <v-tabs v-model="activeTab" :height="60" background-color="background" show-arrows hide-slider center-active>
          <v-tab>{{ $t('tslContractors.clients') }}</v-tab>
          <v-tab>{{ $t('tslContractors.carriers') }}</v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-card class="py-5">
            <ClientsTable ref="clientsTable" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="py-5">
            <CarriersTable ref="carriersTable" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <TSLImportDialog v-model="importDialogOpen" @imported="onImported" />
  </div>
</template>

<script>
import ClientsTable from './tables/ClientsTable'
import CarriersTable from './tables/CarriersTable'
import TSLImportDialog from './dialogs/TSLImportDialog'

export default {
  name: 'TSLContractors',
  components: {
    ClientsTable,
    CarriersTable,
    TSLImportDialog
  },
  data () {
    return {
      activeTab: null,
      importDialogOpen: false
    }
  },
  methods: {
    openImportDialog () {
      this.importDialogOpen = true
    },
    onImported () {
      // Refresh tables after import
      if (this.$refs.clientsTable) {
        this.$refs.clientsTable.loadContractors()
      }
      if (this.$refs.carriersTable) {
        this.$refs.carriersTable.loadContractors()
      }
    }
  }
}
</script>

<style scoped>
.v-tab::before {
  display: block;
  content: attr(title);
  font-weight: bold;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.v-tab:hover {
  color: var(--v-primary-base) !important;
  text-shadow: 0 0 .7px var(--v-primary-base), 0 0 .7px var(--v-primary-base);
}

.v-tab--active:hover,
.v-tab--active {
  font-weight: bold;
  color: var(--v-primary-base) !important;
  text-shadow: none;
}

.v-tab {
  border-left: solid 1px var(--v-separator-base);
  margin: 10px 0;
}

.v-tab:last-child {
  border-right: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
</style>
